import _, { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalLoading from "../components/ModalLoading";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@nextui-org/react";
import { requestAuthPost, requestAuthGet } from "../api/authInstance";
import { useAuth } from "../components/auth/authContext";
import { sheetNotify, toastNotify } from "../utils/Utils";
import { useTranslation } from "react-i18next";
import CardSection from "./Card/CardSection";

export default function ModalMechanism({
  setMenu,
  isOpen,
  setIsOpen,
  mechanism,
  brands,
  sku,
  redemptionMethod,
}) {
  const { userData } = useAuth();
  const [qrResult, setQrResult] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("scan");
  const [isScanned, setIsScanned] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const { t } = useTranslation();

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  useEffect(() => {
    if (selected === "manual") {
      getData("");
    }
  }, [selected]);

  async function getData(search) {
    // show modal loading until data loaded
    setIsLoading(true);
    try {
      // get list voucher active
      let res = await requestAuthGet(`project`, {
        params: {
          isActive: true,
          retailer: userData?.outlet?.retailer?.id,
          keyword: search,
        },
      });
      setProjectData(res.data.data);
    } catch (error) {
      console.error(error);
    }
    // hide modal loading after data is loaded
    setIsLoading(false);
  }

  const debounced = useCallback(debounce(getData, 500), []);

  const navigate = useNavigate();

  /**
   * Function to check the voucher
   * @param {string} qrResult the QR code result
   */
  async function CheckVoucher() {
    setShowModalLoading(true);

    // check voucher via API
    requestAuthPost("uvc/check", {
      uvc: qrResult,
      retailer: userData?.outlet?.retailer?.id,
    }).then((res) => {
      if (res.error) {
        // if voucher is invalid, show error message
        setIsScanned(false);
        // sheetNotify(
        //   {
        //     title: res.message[0],
        //     detail: res.detailMessage,
        //   },
        //   setSheetDetail,
        // );
        toastNotify(res.message[0], "error");
        setIsScanned(false);
      } else {
        // if voucher is valid, navigate to confirm voucher page
        if (!_.isEmpty(res)) {
          navigate("/confirm-voucher", {
            state: { detailVoucher: res.data.data },
          });
        }
      }
    });
    setShowModalLoading(false);
  }

  /**
   * This useEffect will be triggered when the QR code is scanned
   * and the `isScanned` state is true. It will call the `CheckVoucher`
   * function to check the voucher via API.
   */
  useEffect(() => {
    if (isScanned) {
      CheckVoucher();
    }
    // eslint-disable-next-line
  }, [isScanned]);

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <Modal
        isOpen={isOpen}
        placement="bottom-center"
        scrollBehavior="inside"
        onOpenChange={setIsOpen}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 rounded-t-lg bg-gradient-to-br from-blue-50 via-purple-50  to-soft-red-50 p-0">
                <div className="px-4 py-5">Mekanisme</div>
                <div className="h-3 rounded-t-lg bg-white"></div>
              </ModalHeader>
              <ModalBody className="rounded-t-lg bg-white py-4">
                <CardSection title="Mekanisme">
                  <p className="text-xs text-monochrome-400">{mechanism}</p>
                </CardSection>
                <CardSection title="Brand">
                  <div className="flex flex-col gap-2">
                    {(brands ? brands : sku)
                      .reduce((acc, item) => {
                        const brandId = item.brand?.id || item.id;
                        if (!acc.find((b) => b.id === brandId)) {
                          acc.push({
                            id: brandId,
                            name: item.brand?.name || item.name,
                          });
                        }
                        return acc;
                      }, [])
                      .map((uniqueItem, i) => (
                        <p key={i} className="text-xs text-monochrome-400">
                          <span className="mr-2 text-sm">&bull;</span>
                          {uniqueItem.name}
                        </p>
                      ))}
                  </div>
                </CardSection>
                {redemptionMethod !== "MANUAL" && (
                  <CardSection title="SKU">
                    <div className="flex flex-col gap-3">
                      {sku.map((item, i) => (
                        <div className="flex items-center gap-2">
                          <div className="h-5 w-5 rounded-sm bg-monochrome-100"></div>
                          <p className="text-xs font-semibold">{item?.name}</p>
                        </div>
                      ))}
                    </div>
                  </CardSection>
                )}
              </ModalBody>
              <ModalFooter>
                {/* <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" onPress={onClose}>
                  Action
                </Button> */}
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
